import {z} from '@hono/zod-openapi';

import {amount} from './amount';
import {count} from './count';
import {DeadStockBucketSchema} from './DeadStockBucketSchema';

export const DeadStockSummaryBucketSchema = z
  .object({
    bucket: DeadStockBucketSchema,
    // NULL when the bucket holds a card with an unpriced movement - unknown, not zero.
    inventoryValue: amount.nullable(),
    cardCount: count,
  })
  .openapi('DeadStockSummaryBucket');

export type DeadStockSummaryBucket = z.infer<typeof DeadStockSummaryBucketSchema>;
